import React, { useEffect } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';

import { useStyles } from './styles';
import { Modal } from '../../../../../components/migrated/modal';
import { ImageDownloadButton } from '../imageDownloadButton/index';
import { useEnvironment, useSnackbar } from '../../../../../hooks';
import ListaVazia from 'components/util/listaVazia/.mixins/ListaVazia';
import { useQualityReturnPictureListGql } from 'pages/quality/productReturnView/graphql/returnPictureList';

interface IPicturesModalProps {
  personId: number;
  returnReceiptId: number;
  open: boolean;
  handleClose: (arg: boolean) => void;
}

export const PicturesModal = (props: IPicturesModalProps) => {
  const { personId, returnReceiptId, open, handleClose } = props;
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const classes = useStyles();

  const {
    runQualityReturnPictureListGql,
    dataQualityReturnPictureList,
    errorQualityReturnPictureList,
    loadingQualityReturnPictureList
  } = useQualityReturnPictureListGql();

  useEffect(() => {
    if (errorQualityReturnPictureList) {
      if (DEBUG === 'TRUE') {
        const msg = errorQualityReturnPictureList;
        console.log(`Erro ao carregar dados! Error:(message: ${msg} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar informações. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorQualityReturnPictureList]);

  useEffect(() => {
    if (open) {
      runQualityReturnPictureListGql({ variables: { personId, returnReceiptId } });
    }
  }, [open]);

  return (
    <>
      <Snackbar />
      <Modal open={open} onClose={handleClose} title="IMAGENS">
        <div className={classes.container}>
          {loadingQualityReturnPictureList && (
            <div className={classes.loader}>
              <CircularProgress />
            </div>
          )}
          {!loadingQualityReturnPictureList && dataQualityReturnPictureList.length > 0 && (
            <Grid item xs={12} sm={12} md={12}>
              <div className={classes.imageContainer}>
                {dataQualityReturnPictureList?.map((upload, key) => (
                  <div key={key} className={classes.image} style={{ backgroundImage: `url(${upload.objectURL})` }}>
                    <ImageDownloadButton imageKey={upload.objectKey} />
                  </div>
                ))}
              </div>
            </Grid>
          )}
          {!loadingQualityReturnPictureList && dataQualityReturnPictureList.length === 0 && (
            <ListaVazia
              tipoMensagem="Alert"
              text="Não encontramos imagens"
              textDescription="Para o relatório selecionado"
            />
          )}
        </div>
      </Modal>
    </>
  );
};
